import type { UserPreferencesNotificationsProps } from "./user-preferences-notifications.type";

import { Flex } from "antd";
import { useTranslation } from "react-i18next";

import { groupNotificationsByType } from "@/entities/referential/referential-notifications";

import { UserPreferencesNotificationsFooter } from "./user-preferences-notifications-footer";
import { UserPreferencesNotificationsHeader } from "./user-preferences-notifications-header";
import { UserPreferencesNotificationsTable } from "./user-preferences-notifications-table";
import { UserPreferencesNotificationsProvider } from "./user-preferences-notifications.provider";

import "./user-preferences-notifications.style.less";

export const UserPreferencesNotifications = ({
  notifications,
  savedSettings,
}: UserPreferencesNotificationsProps) => {
  const { t } = useTranslation();

  const notificationsByType = groupNotificationsByType(notifications);

  return (
    <UserPreferencesNotificationsProvider
      notifications={notifications}
      savedSettings={savedSettings}
    >
      <Flex vertical className="user-preferences-notifications" gap={24}>
        <UserPreferencesNotificationsHeader notifications={notifications} />
        {Object.entries(notificationsByType).map(([type, notifications]) => (
          <UserPreferencesNotificationsTable
            key={type}
            title={t(`user:preferences.notifications.groupsTitle.${type}`)}
            notifications={notifications}
          />
        ))}
        <UserPreferencesNotificationsFooter />
      </Flex>
    </UserPreferencesNotificationsProvider>
  );
};
